module.exports = __webpack_public_path__ + "img/2diamante.1451de5d.png";